import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
  icon: IconType;
  size?: string;
  color?: string;
  'aria-hidden'?: boolean;
}

const Icon: React.FC<IconProps> = ({ icon: IconComponent, size, color, ...rest }) => {
  return <>{IconComponent({ size, color, ...rest })}</>;
};

export default Icon;

